module.exports = __webpack_public_path__ + "img/Blockdit Primary Logo.fe4f6c4a.png";